<div id="chart-container">
  <canvas id="chart-canvas" baseChart 
  [datasets]="looseDatasets" 
  [labels]="chart.labels" 
  [type]="'pie'"
  [options]="chartOptions"
  [style.width]="'100%'">
  </canvas>
</div>
